import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxContainer, CustomCheckbox, Label, PromptContainer, PromptText } from './style';
interface WarningPromptProps {
  acceptedWarningCallback: (input: boolean) => void;
}

/**
 * Warning prompt component
 * @param acceptedWarningCallback - callback to handle checkbox click
 * @returns JSX.Element
 */
function WarningPrompt({ acceptedWarningCallback }: WarningPromptProps): JSX.Element {
  const { t }                 = useTranslation('accountHelp');
  const [checked, setChecked] = useState<boolean>(false);

  /**
   * Handle checkbox click
   */
  const handleCheckboxClick = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    acceptedWarningCallback(newChecked);
  };

  return (
    <PromptContainer>
      <PromptText>{t('ContactUs--warningPrompt-text')}</PromptText>
      <CheckboxContainer onClick={handleCheckboxClick}>
        <CustomCheckbox checked={checked} />
        <Label>{t('ContactUs--warningPrompt-checkbox-label')}</Label>
      </CheckboxContainer>
    </PromptContainer>
  );
}

export default WarningPrompt;